import { render } from "./Tab3.vue?vue&type=template&id=f9383296"
import script from "./Tab3.vue?vue&type=script&lang=ts"
export * from "./Tab3.vue?vue&type=script&lang=ts"
script.render = render

export default script